import { AccountType as z, ButtonAlignment as k } from "@nextgen-web-framework/all";
import { D as U, A as G } from "./profileEnums-82f21da0.mjs";
import { _ as te } from "./cmsConstants-95f19583.mjs";
import { Q as M } from "./profileApi-04b19141.mjs";
import { d as S, h as Y, b as R, f as W, e as F, m as ae, o as V } from "./helper-bed9746b.mjs";
import { e as Q } from "./profileConstantsEnum-b0e79f3e.mjs";
import { Y as ne } from "./cmsTransformer-fa124f69.mjs";
import { cmsApi as oe } from "@commerce-webcomponents/sdk";
import { StorageService as Z, DateFormats as J } from "@nextgen-web-framework/core";
import { ErrorConstants as se, AccountLifeCycleConstants as v } from "./utils/Constants.js";
import { g as j, M as X, F as B } from "./myAccountProfileUtils-f5c6715f.mjs";
const re = {
  Started: "STARTED",
  SubmitStarted: "SUBMIT_STARTED",
  MdmsAccountRegistered: "MDMS_ACCOUNT_REGISTERED",
  Completed: "COMPLETED",
  CompletedByAutoRenew: "COMPLETED_BY_AUTO_RENEW",
  CoapplicantInvited: "COAPPLICANT_INVITED",
  ReadyToSendInvitation: "READY_TO_SEND_INVITATION"
}, $ = {
  Active: "ACTIVE",
  Inactive: "INACTIVE"
}, x = {
  AlreadyRenewed: "ALREADY_RENEWED",
  CanRenew: "CAN_RENEW",
  MustRenew: "MUST_RENEW",
  CannotRenew: "CANNOT_RENEW"
}, q = {
  Processing: "PROCESSING",
  None: "NONE",
  Completed: "COMPLETED"
}, H = {
  responseBody: {
    code: se.GENERAL_ERROR_CODE
  }
}, Le = async (t, a, n = re.Started, e = !1, r = S) => {
  try {
    const { registrations: c } = await r(
      () => M.getRegistration({
        accountNumber: parseInt(a),
        status: n,
        registrationFlow: t
      })
    ), [o] = c || [], { registrationId: s = "" } = o;
    return s;
  } catch (c) {
    if (e)
      return "";
    throw c ?? H;
  }
}, Oe = async (t, a = S) => {
  try {
    const { registrationId: n = "" } = await a(
      () => M.createRegistrationId({
        registrationFlow: t
      })
    );
    return n;
  } catch (n) {
    throw n != null && n.responseBody ? n : H;
  }
}, ce = async (t, a = S) => {
  try {
    return await a(() => M.getAccountInformation(t));
  } catch {
    return {
      name: {
        name: ""
      },
      expirationDate: ""
    };
  }
}, K = async (t, a = S) => {
  var n;
  try {
    const e = await a(() => M.getAccountAutoRenewal(t)), { autoRenewDetails: r } = e, c = (r == null ? void 0 : r.signedUpFlag) ?? !1, o = ((n = r == null ? void 0 : r.subscription) == null ? void 0 : n.pauseCd) !== "N", s = Z.getSessionStorage(), l = {
      lastUpdate: (/* @__PURE__ */ new Date()).toISOString(),
      autoRenewEnabled: c,
      autoRenewPaymentFailed: o
    };
    return s.store(Q.accountRenewalAttributes, l), {
      autoRenewEnabled: c,
      autoRenewPaymentFailed: o,
      autoRenewDetails: r
    };
  } catch {
    return {
      autoRenewEnabled: !1,
      autoRenewPaymentFailed: !1
    };
  }
}, le = async (t, a = S) => {
  const n = await a(() => M.getAccountByNum(t)), { profileList: e } = n ?? { profileList: [] };
  return e;
}, Ne = (t, a, n) => {
  var e;
  return a ? (a == null ? void 0 : a.toLowerCase()) === ((e = String(t == null ? void 0 : t.pk)) == null ? void 0 : e.toLowerCase()) ? Y.Citizen : Y.Foreigner : R(n, Y.Citizen);
}, he = async (t, a, n, e, r = S) => {
  if (n === z.Member) {
    const o = (await le(t, r)).find((s) => s.primary);
    if ((o == null ? void 0 : o.profileId) === a)
      return e;
    if (o != null && o.profileId) {
      const s = await ie(o == null ? void 0 : o.profileId, r);
      return R(s == null ? void 0 : s.citizenship);
    }
  }
  return "";
}, ie = async (t, a = S) => {
  try {
    return await a(() => M.getProfilesById(t));
  } catch {
    return {};
  }
}, Me = (t) => t ? k.HORIZONTAL : k.VERTICAL, we = {
  allowRenewal: !1,
  renewalConfig: {
    renewalPeriodType: U.EXPIRY_DATE
  },
  allowAutoRenewal: !1,
  allowUpgrade: !1,
  upgradeConfig: {
    validCitizenCountryCode: "",
    upgradeMinAge: 0
  },
  allowDowngrade: !1,
  useProfileCart: !1
}, de = (t, a, n, e) => {
  const { allowRenewal: r, renewalConfig: c } = t, { renewalPeriodType: o, showFullDate: s, config: l } = c;
  if (!r || !l)
    return {
      allowRenewal: !1,
      renewalStartDate: new Date(a),
      gracePeriodDate: new Date(a),
      isLastGraceMonth: !1,
      formattedRenewalStartDate: "",
      formattedExpiryDate: new Date(a).toISOString(),
      formattedGracePeriodDate: new Date(a).toISOString()
    };
  const u = /* @__PURE__ */ new Date(), f = new Date(R(a)), w = new Date(f);
  w.setDate(1);
  const i = new Date(R(a)), T = W(i == null ? void 0 : i.toString(), n, e), d = new Date(f);
  let L = !1;
  if (o === U.FIXED_MONTH) {
    const { renewalMonthStart: p, renewalMonthEnd: D } = l;
    w.setMonth(F(p) - 1), d.setFullYear(w.getFullYear() + 1), d.setMonth(F(D), 1), d.setDate(0);
  } else if (o === U.EXPIRY_DATE) {
    const { renewalWindowPeriodMonths: p, renewalGracePeriodMonths: D, alertOnLastGraceMonth: h } = l;
    w.setMonth(w.getMonth() - F(p)), d.setMonth(d.getMonth() + F(D) + 1), d.setDate(0), h && d.getMonth() === u.getMonth() && (L = !0);
  }
  const O = W(w.toString(), n, J.SHORT_DATE), N = new Date(O).getFullYear(), b = s ? O : `${w.getMonth() + 1}/${N}`, m = W(d.toString(), n, e);
  return {
    allowRenewal: r,
    renewalStartDate: w,
    gracePeriodDate: d,
    isLastGraceMonth: L,
    formattedRenewalStartDate: b,
    formattedExpiryDate: T,
    formattedGracePeriodDate: m
  };
}, ue = ({
  type: t,
  accountExpirationDate: a,
  renewalStatus: n,
  accountStatus: e,
  locale: r,
  dateFormat: c,
  renewalLifecycle: o,
  businessNatureLifeCycle: s,
  lifeCycleConfig: l,
  isAutoRenewalEnabled: u = !1,
  isAutoRenewalFailed: f = !1
}) => {
  const w = /* @__PURE__ */ new Date(), {
    allowRenewal: i,
    renewalStartDate: T,
    isLastGraceMonth: d,
    formattedRenewalStartDate: L,
    formattedExpiryDate: O,
    formattedGracePeriodDate: N
  } = de(l, a, r, c), { renewalConfig: b } = l, { config: m } = V(b), { allowLateRenew: p } = V(m), D = t === z.BusinessOwner, h = T.getTime() <= w.getTime(), P = [x.CanRenew, x.MustRenew].includes(
    R(n)
  ) && e === $.Active, y = i && (!o || o && o !== q.Processing) && (!s || s && s !== q.Completed), g = y && h && P, A = y && n === x.MustRenew, C = p && A, I = A || g && (!u || f && u);
  return {
    expiryDate: O,
    rawExpiryDate: a,
    // return original date
    inactiveDate: N,
    renewalStartDate: L,
    mustRenew: A,
    canRenew: g,
    canLateRenew: C,
    canUpgrade: !D && e === $.Active && y,
    canDowngrade: D && P && y,
    isAutoRenewalEnabled: u,
    isAutoRenewalFailed: f,
    showRenewalNudge: I,
    isABO: D,
    type: t,
    isLastGraceMonth: d
  };
}, be = async (t, a = S) => {
  var e, r, c;
  const n = {
    title: "",
    description: ""
  };
  try {
    const o = await a(
      () => oe.fetchContent({
        uId: te.ACCOUNT_LIFE_CYCLE
      })
    ), s = ne(
      o
    );
    let l;
    switch (t) {
      case G.Renewal:
        l = (e = s == null ? void 0 : s.data) == null ? void 0 : e.renewalTermsCondition;
        break;
      case G.Upgrade:
        l = (r = s == null ? void 0 : s.data) == null ? void 0 : r.upgradeTermsCondition;
        break;
      case G.Downgrade:
        l = (c = s == null ? void 0 : s.data) == null ? void 0 : c.downgradeTermsCondition;
        break;
      default:
        l = n;
    }
    return l ?? n;
  } catch {
    return n;
  }
}, fe = {
  expiryDate: "",
  rawExpiryDate: "",
  inactiveDate: "",
  renewalStartDate: "",
  mustRenew: !1,
  canRenew: !1,
  canLateRenew: !1,
  canUpgrade: !1,
  canDowngrade: !1,
  isAutoRenewalEnabled: !1,
  isAutoRenewalFailed: !1,
  showRenewalNudge: !1,
  isABO: !1,
  type: z.Member
}, Pe = async (t, a, n, e, r = !1, c = S) => {
  var h, P, y;
  const { aboNum: o } = t, [s] = String(n).split("-");
  let l = fe;
  if (!o)
    return e == null || e(l), l;
  let u, f, w, i, T;
  if (r) {
    const { type: g, accountExpirationDate: A, renewalStatus: C, renewalLifecycle: I, accounts: _ } = t, E = (h = _ == null ? void 0 : _.find(
      (ee) => String(ee.accountNumber) === String(o)
    )) == null ? void 0 : h.accountStatus;
    u = R(A), f = R(C), w = R(I), i = g, T = E;
  } else {
    const g = await ce(o, c), { accountType: A, expirationDate: C, renewalStatus: I, renewalLifecycle: _, status: E } = g;
    u = R(C), w = R(_), f = R(I), i = A, T = E;
  }
  const d = j(
    a,
    X.STEP_GENERAL_CONFIG
  ), L = (y = (P = d == null ? void 0 : d.dateFormat) == null ? void 0 : P.transformation.find(
    (g) => (g == null ? void 0 : g.siteLocale) === s
  )) == null ? void 0 : y.dateLocale, { inputs: O } = j(a, X.STEP_ACCOUNT_LIFE_CYCLE), N = Re(O, i), { allowAutoRenewal: b } = N;
  let m = !1, p = !1, D = !1;
  if (b) {
    if (r) {
      const A = Z.getSessionStorage().retrieve(
        Q.accountRenewalAttributes
      ), { lastUpdate: C, autoRenewEnabled: I, autoRenewPaymentFailed: _ } = A || {};
      if (C)
        m = !!I, p = !!_, D = !0;
      else {
        const E = await K(o, c);
        m = !!(E != null && E.autoRenewEnabled), p = !!(E != null && E.autoRenewPaymentFailed);
      }
    }
    if (!D) {
      const { autoRenewEnabled: g, autoRenewPaymentFailed: A } = await K(o, c);
      m = !!g, p = !!A;
    }
  }
  return l = ue({
    type: i,
    isAutoRenewalEnabled: m,
    isAutoRenewalFailed: p,
    accountExpirationDate: String(u),
    renewalStatus: f,
    renewalLifecycle: w,
    accountStatus: T,
    locale: L ?? s,
    dateFormat: J.SHORT_DATE,
    lifeCycleConfig: N
  }), e == null || e(l), l;
}, ge = (t) => {
  const a = B(t, v.RENEWAL_CONFIG);
  return a || {
    visible: !1,
    renewalPeriodType: U.EXPIRY_DATE,
    showFullDate: !1,
    memberType: []
  };
}, Re = (t, a) => {
  if (!t || t.length === 0)
    return we;
  const n = ae(), e = ge(t), r = Array.isArray(e == null ? void 0 : e.memberType) ? e.memberType.find(
    (i) => i.memberType === a && (Array.isArray(i == null ? void 0 : i.env) && i.env.includes(n) || !(i != null && i.env))
  ) : void 0, c = B(t, v.ALLOW_AUTO_RENEWAL), o = B(t, v.ALLOW_UPGRADE), { visible: s, validCitizenCountryCode: l, minor: u } = o, f = B(t, v.ALLOW_DOWNGRADE), w = B(t, v.USE_PROFILE_CART);
  return {
    allowRenewal: !!(e != null && e.visible),
    // Market specific will override this setting. (eg: MEMBER not allow renew)
    renewalConfig: {
      renewalPeriodType: R(e == null ? void 0 : e.renewalPeriodType),
      showFullDate: !!(e != null && e.showFullDate),
      config: r
    },
    allowAutoRenewal: !!(c != null && c.visible),
    allowUpgrade: !!s,
    upgradeConfig: {
      validCitizenCountryCode: String(l),
      upgradeMinAge: F(u == null ? void 0 : u.min)
    },
    allowDowngrade: !!(f != null && f.visible),
    useProfileCart: !!(w != null && w.value)
  };
};
export {
  q as I,
  x as _,
  Le as a,
  Pe as b,
  Me as c,
  ce as d,
  Re as e,
  fe as f,
  be as g,
  Oe as h,
  re as i,
  Ne as j,
  he as k,
  K as l,
  le as m,
  ie as n,
  de as o,
  ue as p,
  ge as q
};
//# sourceMappingURL=accountLifeCycleUtils-8febd922.mjs.map
